import { Component, inject, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';
import {
  FormsModule,
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import {
  EstadoVagaEnum,
  ProfissaoCatalogoListItemDTO,
  Vaga,
  VagaListItemDTO,
} from '@app/features-modules/bolsa-de-profissionais/api';
import { CommonModule } from '@angular/common';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { Menu, MenuModule } from 'primeng/menu';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  TableColumn,
  TableComponent,
} from '@shared/components/table/table.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import {
  VagaService,
  ProfissaoCatalogoService,
  ProfissionalService,
  EmpresaSectorService,
} from '../../../services';
import { ApiService } from '@core/providers/http';
import { ProfissionaisEnumService } from '../../../services';
import { forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { Toast } from 'primeng/toast';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-home-vagas',
  imports: [
    CommonModule,
    SearchBarComponent,
    FormsModule,
    TableModule,
    PaginatorControlComponent,
    ConfirmDialogModule,
    ButtonModule,
    TableComponent,
    TagModule,
    MenuModule,
    Menu,
    DataVoidComponent,
    DialogModule,
    SelectModule,
    ReactiveFormsModule,
    DatePicker,
    BackButtonComponent,
    Toast,
  ],
  providers: [
    DialogService,
    MessageService,
    DialogService,
    TableComponent,
    ConfirmationService,
    ApiService,
    EmpresaSectorService,
    VagaService,
    ProfissaoCatalogoService,
    ProfissionalService,
    ProfissionaisEnumService,
  ],
  templateUrl: './home-vagas.component.html',
  styleUrl: './home-vagas.component.scss',
  standalone: true,
})
export class HomeVagasComponent implements OnInit {
  empresaService = inject(EmpresaSectorService);
  messageService = inject(MessageService);
  pagination: Pagination<Vaga> = new Pagination<Vaga>();
  private auth = inject(AuthStore);
  router = inject(Router);
  dialogService = inject(DialogService);
  profissionalService = inject(ProfissionalService);
  vagaService = inject(VagaService);
  profissaoService = inject(ProfissaoCatalogoService);
  profissionalenumService = inject(ProfissionaisEnumService);
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];
  listaVagas: VagaListItemDTO[] = [];
  listaEmpresas: any[] = [];
  listaRegimeTrabalho: any[] = [];

  constructor(public fb: FormBuilder) {}

  filter = {
    profissionalId: 0,
    vagaId: 0,
  };

  filterProfissoes = {
    designacaoISCO: '',
    codigoISCO: '',
    codigoCPA: '',
    designacaoCPA: '',
  };

  filtrarVagas = {
    designacaoFuncao: '',
    codgoFuncao: '',
    codigo: '',
  };

  accoes = [
    {
      label: 'Ver Detalhes da Vaga',
      icon: 'pi pi-desktop',
      command: ($event: any) => this.detalhesVaga($event as any),
    },
    // {
    //   label: 'Editar vaga',
    //   icon: 'pi pi-pencil',
    //   command: () => this.editarVaga(),
    // },
    {
      label: 'Gerar Comprovativo',
      icon: 'pi pi-file-pdf',
      command: ($event: any) => this.onGerarComprovativo($event as any),
    },
  ];

  estadoOption = [
    { id: EstadoVagaEnum.NUMBER_1, designacao: 'Aberto' },
    { id: EstadoVagaEnum.NUMBER_2, designacao: 'Fechado' },
    { id: EstadoVagaEnum.NUMBER_3, designacao: 'Cancelado' },
  ];

  groupPersonList = [
    { label: 'Responsável', value: 1 },
    { label: 'Técnico', value: 2 },
    { label: 'Operário', value: 3 },
    { label: 'Administração e Serviços', value: 4 },
  ];
  vagaSelecionada: Vaga | undefined | null;

  // columns: TableColumn[] = [
  //   { field: 'empresa', header: 'Empresa' },
  //   { field: 'designacaoFuncao', header: 'Função de Referência' },
  //   {
  //     field: 'numVaga',
  //     header: 'Vagas Abertas',
  //     type: 'badge',
  //     severityField: 'help',
  //   },
  //   {
  //     field: 'totalCandidaturas',
  //     header: 'Nº de candidaturas',
  //     type: 'badge',
  //     severityField: 'estadoVaga',
  //     badgeSeverityFunction: (rowData: any) =>
  //       rowData.estadoVaga === 'Aberto' ? 'info' : 'info',
  //   },
  //   { field: 'data', header: 'Data de Abertura' },
  //   {
  //     field: 'estadoVaga',
  //     header: 'Estado',
  //     type: 'tag',
  //     severityField: 'estadoVaga',
  //     tagSeverityFunction: (rowData: any) =>
  //       rowData.estadoVaga === 'Aberto' ? 'success' : 'info',
  //   },
  // ];

  columns: TableColumn[] = [
    { field: 'codigo', header: 'Código função' },
    { field: 'designacaoFuncao', header: 'Função de Referência' },
    {
      field: 'numVaga',
      header: 'Vagas Disponíveis',
      type: 'badge',
      severityField: 'help',
    },
    {
      field: 'totalCandidaturas',
      header: 'Nº de candidaturas',
      type: 'badge',
      severityField: 'estadoVaga',
      badgeSeverityFunction: (rowData: any) =>
        rowData.estadoVaga === 'Aberto' ? 'info' : 'info',
    },
    {
      field: 'dataCricao',
      header: 'Data Criação',
    },
    { field: 'dataEncerramento', header: 'Data Encerramento' },
    {
      field: 'estadoVaga',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoVaga',
      tagSeverityFunction: (rowData: any) =>
        rowData.estadoVaga === 'Aberto' ? 'success' : 'info',
    },
  ];

  sortFields: any[] = [
    { label: 'codigo', value: 'codigo' },
    { label: 'Profissão de referência', value: 'designacaoFuncao' },
  ];
  isLoading = false;
  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'EmpresaID',
      placeholder: 'Empresa',
      options: this.listaEmpresas,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'ProfissaoCatalogoID',
      placeholder: 'Profissão de referência',
      options: this.listaProfissoes,
      optionLabel: 'designacaoISCO',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'regime',
      placeholder: 'Regime de Trabalho',
      options: this.listaRegimeTrabalho,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'grupoTrabalho',
      placeholder: 'Grupo de Trabalho',
      options: this.groupPersonList,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'date',
      controlName: 'dataAbertura',
      placeholder: 'Data de Abertura',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'date',
      controlName: 'dataEncerramento',
      placeholder: 'Data de Encerramento',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoVaga',
      placeholder: 'Estado',
      options: this.estadoOption,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  date: Date | undefined;
  minDate: Date | undefined;
  maxDate: Date | undefined;
  vagasCount: any;
  form!: FormGroup;

  ngOnInit(): void {
    this.getProfissoes();
    this.getAllEmpresas();
    this.loadVagas();
    this.loadDropdowns();

    // let today = new Date();
    // let month = today.getMonth();
    // let year = today.getFullYear();
    // let prevMonth = (month === 0) ? 11 : month - 1;
    // let prevYear = (prevMonth === 11) ? year - 1 : year;
    // let nextMonth = (month === 11) ? 0 : month + 1;
    // let nextYear = (nextMonth === 0) ? year + 1 : year;
    // this.minDate = new Date();
    // this.minDate.setMonth(prevMonth);
    // this.minDate.setFullYear(prevYear);
    // this.maxDate = new Date();
    // this.maxDate.setMonth(nextMonth);
    // this.maxDate.setFullYear(nextYear);

    this.form = this.fb.group({
      ProfissaoCatalogoID: [null],
      EmpresaID: [null],
      regime: [null],
      grupoTrabalho: [null],
      dataAbertura: [null],
      dataEncerramento: [null],
      EstadoVaga: [null],
    });
  }

  loadDropdowns() {
    forkJoin({
      regime: this.profissionalenumService.getAllRegimeTrabalho(),
    }).subscribe((response) => {
      if (response.regime?.data) {
        this.listaRegimeTrabalho = Object.entries(response.regime.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[2].options = this.listaRegimeTrabalho;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadVagas();
  }

  onGerarComprovativo(event: any) {
    const vagaId = event?.item?.data?.id ?? event?.data?.id;
    if (!vagaId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não foi possível identificar a vaga.',
        life: 3000,
      });
      return;
    }

    this.isLoading = true;
    this.profissionalService.gerarComprovativo({ VagaId: vagaId }).subscribe({
      next: (blob) => {
        this.isLoading = false;

        const filename = `comprovativo-vaga-${vagaId}.pdf`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Comprovativo',
          detail: 'Comprovativo gerado com sucesso.',
          life: 3000,
        });
      },
      error: (err) => {
        this.isLoading = false;
        console.error('gerarComprovativo error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha ao gerar comprovativo.',
          life: 4000,
        });
      },
    });
  }

  detalhesVaga(event: any): void {
    if (this.auth.hasAny(['Consultar_Vagas_Emprego'])) {
      this.router.navigate([
        `/bolsa-profissionais/vagas/detalhe-vaga/${
          event?.id || this.vagaSelecionada?.id
        }`,
      ]);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  editarVaga() {}

  getProfissoes() {
    this.profissaoService.list().subscribe((result) => {
      if (result.data) {
        this.listaProfissoes = result.data;
        this.filters[1].options = this.listaProfissoes.map((profissao) => ({
          ...profissao,
          designacaoISCO: `${profissao.codigoISCO} - ${profissao.designacaoISCO}`,
        }));
      }
    });
  }
  loadVagas(filters?: any) {
    const params = {
      ...filters,
      OrderBy: 'id desc',
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
    };

    this.vagaService.list(params).subscribe((result) => {
      if (result.data) {
        this.pagination = new Pagination<any>().deserialize(result);
        this.vagasCount = this.pagination?.totalRecords;
      } else {
        this.messageService.add({
          severity: 'Error',
          summary: 'Erro',
          detail: 'Erro ao buscar vagas',
          life: 3000,
        });
      }
    });
  }

  getSeverity(estado: string): any {
    switch (estado) {
      case 'Aberta':
        return 'success';
      case 'Fechado':
        return 'danger';
      default:
        return 'success';
    }
  }

  actionClick(vaga: Vaga) {
    this.vagaSelecionada = vaga;
  }

  getAllEmpresas(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.listaEmpresas = res.data;
        this.filters[0].options = this.listaEmpresas;
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
      },
    );
  }

  detalhelink() {
    //this.router.navigate([`/bolsa-profissionais/vagas/detalhe-vaga/`]);
  }

  handleFormValueChange(event: any) {
    this.showFilter = false;
    // this.showFilter = false;
    console.log(event);
    // Filtra apenas os valores não nulos, não indefinidos e não vazios
    const filters = Object.keys(event).reduce(
      (acc: Record<string, any>, key) => {
        if (
          event[key] !== null &&
          event[key] !== undefined &&
          event[key] !== ''
        ) {
          acc[key] = event[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );
    console.log('Filtered values:', filters);
    this.loadVagas(filters);
  }

  showFilter = false;

  showDialog() {
    this.showFilter = true;
  }

  /*
  cadastrarConcurso() {
    const ref = this.dialogService.open(CadastrarVagasComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
    });

    ref.onClose.subscribe((data) => {
      this.childComponent.loadAllVagas()
      if (data.refresh) {
        console.log('Form submitted:', data);
      }
    });
  }

  onChangeSector(item: SelectChangeEvent){

  }*/
}
